import { RECENT_SEARCH_KEYWORDS } from "core/constants";
import { SortByText, StatusFilter } from "search/actions";
import { SortAscDesc, SortColumn, TaskStatus } from "typings/globalGQLTypes";

export const getSearchSorting = (sortByText: SortByText) => {
  switch (sortByText) {
    case SortByText.RecentlyCreated:
      return {
        column: SortColumn.created_at,
        order: SortAscDesc.desc,
      };

    default:
      return null;
  }
};

export const statusTextToArrayOfStatuses = (
  statusFilterText: StatusFilter,
): TaskStatus[] => {
  switch (statusFilterText) {
    case StatusFilter.Complete:
      return [TaskStatus.complete];

    case StatusFilter.Incomplete:
      return [
        TaskStatus.ready,
        TaskStatus.canceled,
        TaskStatus.inprogress,
        TaskStatus.waiting,
        TaskStatus.arriving,
        TaskStatus.enroute,
      ];

    default:
      return [
        TaskStatus.complete,
        TaskStatus.ready,
        TaskStatus.canceled,
        TaskStatus.inprogress,
        TaskStatus.waiting,
        TaskStatus.arriving,
        TaskStatus.enroute,
      ];
  }
};

export const getRecentSearchKeywordsFromLocalStorage = () => {
  const localRecentSearchKeywords = localStorage.getItem(
    RECENT_SEARCH_KEYWORDS,
  );

  return localRecentSearchKeywords ? JSON.parse(localRecentSearchKeywords) : [];
};

export const addSearchKeywordToLocalStorage = (searchKeyword: string) => {
  if (searchKeyword.trim() === "") return; // don't add empty string to previousSearchKeywordds

  // remove duplicate keyword
  const recentSearchKeywords = getRecentSearchKeywordsFromLocalStorage().filter(
    (keyword: string) => searchKeyword !== keyword,
  );

  const max10Keywords = [searchKeyword].concat(
    recentSearchKeywords.slice(0, 9),
  );

  localStorage.setItem(RECENT_SEARCH_KEYWORDS, JSON.stringify(max10Keywords));
};
